//Sprint 24 - 9657 - Coleta Imposta - exibir pop-up para usuário

import { HttpService } from "./http.service";
import { ResultRequestModel } from "../models/resultRequest.model";

import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";


const basePath = "/EquipmentAcknowledge";
const request = HttpService.handleRequest();

export const EquipmentAcknowledgeService = {
  sendAcknowledge,
  getEquipmentForcedCollection,
  getEquipmentBalanceLimitExceeded,
  getEquipmentImposedPickupModal
};


async function sendAcknowledge(data: any): Promise<ResultRequestModel> {
  return request.post(`${basePath}/SendAcknowledge`, data);
}

//sprint 27  - 10238 - Relatório Indicador - Coleta imposta sem programação da Filial - Fase 1
async function getEquipmentForcedCollection(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/GetEquipmentForcedCollection`, data);
}

//sprint 28  - 10714 - Equipamentos com limite excedido de saldo online sem programação da Filial - Fase 1
async function getEquipmentBalanceLimitExceeded(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/GetEquipmentBalanceLimitExceeded`, data);
}


async function getEquipmentImposedPickupModal(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/GetEquipmentImposedPickupModal`, data);
}


export default EquipmentAcknowledgeService;